// Индикатор загрузки — MD3 CircularProgress с опциональным Backdrop (полноэкранный режим).
import type { ReactNode } from 'react';
import { Backdrop, CircularProgress, Box } from '@mui/material';

interface LoadingSpinnerProps {
  /** Полноэкранный режим (с затемнением фона). */
  fullScreen?: boolean;
  /** Текст под спиннером (опционально). */
  label?: string;
  /** Размер спиннера в px (default 40). */
  size?: number;
}

/** MD3 индикатор загрузки. */
export function LoadingSpinner({ fullScreen = false, label, size = 40 }: LoadingSpinnerProps): JSX.Element {
  const content: ReactNode = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <CircularProgress size={size} thickness={4} />
      {label ? <Box sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>{label}</Box> : null}
    </Box>
  );

  if (fullScreen) {
    return (
      <Backdrop open sx={{ zIndex: (theme) => theme.zIndex.modal + 1, flexDirection: 'column' }}>
        {content}
      </Backdrop>
    );
  }

  return <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>{content}</Box>;
}
